// extracted by mini-css-extract-plugin
export default {"hover-div":"HeaderCell_hover-div__nWxta","gap":"HeaderCell_gap__9XIDN","gap__cell":"HeaderCell_gap__cell__nLrBD"};